import { Form } from "@unform/web";

import styled from "styled-components";
import media from "styled-media-query";

// Os componentes de Select/Input legados exigem estar dentro de um <Form> do
// @unform (é ele que provê o contexto de `useField`) — mesmo padrão do filtro de
// interesse que já existe no cabeçalho da aba "Seletivas".
export const Wrapper = styled(Form)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-end;
  gap: 12px;
  width: 100%;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
  `}
`;

export const Actions = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;

  button {
    width: auto;
  }
`;
